import GenericProductCodeUtil from 'integration/endorsement/GenericProductCodeUtil';

export default {
    isHomeowners: function isHomeowners(productCode) {
        return GenericProductCodeUtil.getGenericProductCode(productCode) === 'Homeowners';
    },
    isPA: function isPA(productCode) {
        return GenericProductCodeUtil.getGenericProductCode(productCode) === 'PersonalAuto';
    },
    isBOP: function isBOP(productCode) {
        return GenericProductCodeUtil.getGenericProductCode(productCode) === 'BusinessOwners';
    },
    isCP: function isCP(productCode) {
        return GenericProductCodeUtil.getGenericProductCode(productCode) === 'CommercialProperty';
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/endorsement/LobUtil.js
// module id = 166
// module chunks = 0